import { AppType, APP_TYPE } from "../app.type";
import { Injectable, Inject } from "@angular/core";
import { UserSettingsServiceType } from "./user-settings.service.type";
import { getUserSettings, updateUserSettings } from "../api.service";
import { Customer } from "../../../../shared/types/customers";
import { JOBTITLE_OM } from "../users/users.service.type";
import { customers } from "../../../../shared/config/customers";
import {
  OCDefaultEmails,
  defaultOMEmails,
  UserSettings,
} from "../../../../shared/models/user-settings";

@Injectable()
export class UserSettingsService implements UserSettingsServiceType {
  userSettings = new UserSettings();
  currentUserEmailPreferences: number[] = [];
  cleanUserEmailPreferences: number[] = [];
  customerEmailsList = new Set<number>();
  defaultEmails: number[] = [];

  constructor(@Inject(APP_TYPE) private app: AppType) {}

  async getCurrentUserSettings(userName: string) {
    if (userName == null) {
      return;
    }
    this.app.spinner.showSpinner();
    this.userSettings = await getUserSettings(userName);
    if (this.userSettings != null) {
      if (this.app.customers.expectCurrent === Customer.OC) {
        this.defaultEmails = OCDefaultEmails;
      } else {
        this.defaultEmails = defaultOMEmails;
      }
      this.currentUserEmailPreferences = [
        ...this.userSettings.preferences.emails,
      ];
      this.cleanUserEmailPreferences = [...this.currentUserEmailPreferences];
    }

    this.app.spinner.hideSpinner();
  }

  async initSettings() {
    this.getCustomerEmailsList();
    let settingsId: any = this.app.state.userId;
    if (this.app.users.currentUser._id != null) {
      settingsId = this.app.users.currentUser._id;
    }
    await this.getCurrentUserSettings(settingsId);
    this.getCustomerEmailsList();
  }

  getCustomerEmailsList() {
    this.app.list.userSettings.emails.forEach((email) => {
      this.customerEmailsList.add(Number(email));
    });
    if (
      this.app.customers.expectCurrent === Customer.KNDS &&
      this.app.users.currentUser.jobTitle !== JOBTITLE_OM
    ) {
      this.customerEmailsList.delete(21);
    }
    if (!this.app.users.currentUser.roles.includes("ns-team")) {
      this.customerEmailsList.delete(28);
    }

    if (this.app.customers.expectCurrent === Customer.DB) {
      this.customerEmailsList.delete(4);
      this.customerEmailsList.delete(6);
    }
    return Array.from(this.customerEmailsList);
  }

  toggleSettings(quantity: number, email?: string) {
    switch (quantity) {
      case 0:
        this.currentUserEmailPreferences = this.defaultEmails;
        break;

      case 1:
        this.currentUserEmailPreferences = this.addSelectedOptions(email);
        break;
      case quantity:
        this.currentUserEmailPreferences = Array.from(this.customerEmailsList);
        this.currentUserEmailPreferences = [
          ...this.currentUserEmailPreferences,
          ...this.defaultEmails,
        ];
        break;
    }
    this.updateSettings();
  }

  addSelectedOptions(email?: string) {
    const emailNumber = Number(email);
    if (this.currentUserEmailPreferences.includes(emailNumber)) {
      const index = this.currentUserEmailPreferences.indexOf(emailNumber);
      this.currentUserEmailPreferences.splice(index, 1);
    } else {
      this.currentUserEmailPreferences.push(emailNumber);
    }
    return this.currentUserEmailPreferences;
  }

  async updateSettings() {
    /** sets the email preferences */
    this.userSettings.preferences.emails = this.currentUserEmailPreferences;
    await updateUserSettings(this.userSettings);
    this.app.state.next({
      hasSuccess: true,
      successText: this.app.text.userSettings.emailPreferencesSet,
    });
    setTimeout(() => {
      this.app.state.next({ hasSuccess: false });
    }, 3000);
    // get updated user settings
    await this.getCurrentUserSettings(this.userSettings.id);
  }

  async setMFAPreferences() {
    /** sets the MFA preferences */
    this.userSettings.mfaPreferences.email =
      !this.userSettings.mfaPreferences.email;
    await updateUserSettings(this.userSettings);
    this.app.state.next({
      hasSuccess: true,
      successText: this.app.text.userSettings.securityPreferencesSet,
    });

    setTimeout(() => {
      this.app.state.next({ hasSuccess: false });
    }, 3000);
    await this.getCurrentUserSettings(this.userSettings.id);
  }

  showEmailPreferencesBox() {
    var showEmailsBox = false;
    if (
      !this.app.users.isNew &&
      !this.app.auth.isTeam &&
      this.app.customers.expectCurrent !== Customer.OC
    ) {
      showEmailsBox = true;
    }
    return showEmailsBox;
  }
}
